import React from 'react';
import { ArrowUp } from 'lucide-react';
import { CreditBadge } from './CreditBadge';

// Botón de "enviar" con los créditos DENTRO (token pill on-primary + flecha o
// texto), forma píldora, estilo "Generar 🪙N". Se usa en los editores de imagen y
// video del historial para que el botón quede homogéneo entre ambos.
interface SendCreditsButtonProps {
  credits: number;
  onClick: () => void;
  disabled?: boolean;
  ariaLabel?: string;
  /**
   * Texto de la acción en lugar de la flecha (ej. "Editar", "Borrar").
   *
   * Es opcional y no default a propósito: el editor de imagen lo usa para decir qué
   * va a pasar, pero el editor de VIDEO sigue con la flecha. Cambiar el default los
   * tocaría a los dos, y acá sólo se pidió el de imagen.
   */
  label?: string;
}

export const SendCreditsButton: React.FC<SendCreditsButtonProps> = ({
  credits,
  onClick,
  disabled = false,
  ariaLabel = 'Enviar',
  label,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`h-9 pl-2 bg-brand-primary hover:bg-brand-primary-hover disabled:opacity-50 text-white rounded-full font-normal shadow-sm inline-flex items-center gap-1.5 ${
      label ? 'pr-3.5' : 'pr-2.5'
    }`}
    aria-label={ariaLabel}
  >
    <CreditBadge credits={credits} size="sm" tone="on-primary" />
    {label ? (
      <span className="text-[13px] font-medium whitespace-nowrap">{label}</span>
    ) : (
      <ArrowUp className="w-4 h-4" />
    )}
  </button>
);

export default SendCreditsButton;
